<script lang="ts">
  import MessageSolidIcon from "../utils/assets/message_solid_icon.svelte";
  import EmailSolidIcon from "../utils/assets/email_solid_icon.svelte";
  import PhoneSolidIcon from "../utils/assets/phone_solid_icon.svelte";
  import WhatsappSolidIcon from "../utils/assets/whatsapp_solid_icon.svelte";
  import { selected_communication } from "../stores/chat";
  import { client_config } from "../stores/store";
  import type { ModalityConfig } from "../types/globalTypes";
  import { regexForHousinghand } from "../utils/validators";
  import SmsIcon from "../utils/assets/sms_icon.svelte";
  import FbIcon from "../utils/assets/fb_icon.svelte";
  import InstagramSolidIcon from "../utils/assets/instagram_solid_icon_new.svelte";
  import WechatIcon from "../utils/assets/wechat_icon.svelte";

  export let modalityConfig: ModalityConfig;
  export let accentColor = "";
  export let id: string;

  const handleCommunicationToggle = (type: string) => {
    selected_communication.set(type);
  };

  const is_housinghand = id === "housinghand";

  $: call_modality_enabled = is_housinghand
    ? !regexForHousinghand?.test(window?.location?.href) &&
      modalityConfig?.call?.enabled &&
      $client_config?.call_link
    : modalityConfig?.call?.enabled && $client_config?.call_link;

  $: whatsapp_modality_enabled = is_housinghand
    ? !regexForHousinghand?.test(window?.location?.href) &&
      modalityConfig?.whatsapp?.enabled &&
      $client_config?.whatsapp_link
    : modalityConfig?.whatsapp?.enabled && $client_config?.whatsapp_link;

  $: sms_modality_enabled = is_housinghand
    ? !regexForHousinghand?.test(window?.location?.href) &&
      modalityConfig?.sms?.enabled &&
      $client_config?.sms_link
    : modalityConfig?.sms?.enabled && $client_config?.sms_link;

  $: fb_messenger_modality_enabled = is_housinghand
    ? !regexForHousinghand?.test(window?.location?.href) &&
      modalityConfig?.fb_messenger?.enabled &&
      $client_config?.fb_messenger_link
    : modalityConfig?.fb_messenger?.enabled &&
      $client_config?.fb_messenger_link;

  $: instagram_modality_enabled = is_housinghand
    ? !regexForHousinghand?.test(window?.location?.href) &&
      modalityConfig?.instagram?.enabled &&
      $client_config?.instagram_link
    : modalityConfig?.instagram?.enabled && $client_config?.instagram_link;

  $: wechat_modality_enabled = is_housinghand
    ? !regexForHousinghand?.test(window?.location?.href) &&
      modalityConfig?.wechat?.enabled &&
      $client_config?.wechat_link
    : modalityConfig?.wechat?.enabled && $client_config?.wechat_link;
</script>

<div class="verbaflo-widget-communications-container">
  {#if $client_config?.email_link || call_modality_enabled || whatsapp_modality_enabled || sms_modality_enabled || fb_messenger_modality_enabled || instagram_modality_enabled || wechat_modality_enabled}
    <button
      type="button"
      on:click={() => handleCommunicationToggle("message")}
      class={$selected_communication === "message"
        ? "verbaflo-widget-communication-icon-selected"
        : "verbaflo-widget-communication-icon"}
      style="--accent-color: {accentColor};"
    >
      <MessageSolidIcon color={accentColor} />
      {#if $selected_communication === "message"}
        <hr
          class="verbaflo-widget-communication-horizontal-line"
          style="--accent-color: {accentColor};"
        />
      {/if}
    </button>
  {/if}
  {#if modalityConfig?.mail?.enabled && $client_config?.email_link}
    <button
      type="button"
      on:click={() => handleCommunicationToggle("email")}
      class={$selected_communication === "email"
        ? "verbaflo-widget-communication-icon-selected"
        : "verbaflo-widget-communication-icon"}
      style="--accent-color: {accentColor};"
    >
      <EmailSolidIcon />
      {#if $selected_communication === "email"}
        <hr
          class="verbaflo-widget-communication-horizontal-line"
          style="--accent-color: {accentColor};"
        />
      {/if}
    </button>
  {/if}
  {#if whatsapp_modality_enabled}
    <button
      type="button"
      on:click={() => handleCommunicationToggle("whatsapp")}
      class={$selected_communication === "whatsapp"
        ? "verbaflo-widget-communication-icon-selected"
        : "verbaflo-widget-communication-icon"}
      style="--accent-color: {accentColor};"
    >
      <WhatsappSolidIcon />
      {#if $selected_communication === "whatsapp"}
        <hr
          class="verbaflo-widget-communication-horizontal-line"
          style="--accent-color: {accentColor};"
        />
      {/if}
    </button>
  {/if}
  {#if call_modality_enabled}
    <button
      type="button"
      on:click={() => handleCommunicationToggle("phone")}
      class={$selected_communication === "phone"
        ? "verbaflo-widget-communication-icon-selected"
        : "verbaflo-widget-communication-icon"}
      style="--accent-color: {accentColor};"
    >
      <PhoneSolidIcon color={accentColor} />
      {#if $selected_communication === "phone"}
        <hr
          class="verbaflo-widget-communication-horizontal-line"
          style="--accent-color: {accentColor};"
        />
      {/if}
    </button>
  {/if}
  {#if sms_modality_enabled}
    <button 
      type="button"
      on:click={() => handleCommunicationToggle("sms")}
      class={$selected_communication === "sms"
        ? "verbaflo-widget-communication-icon-selected"
        : "verbaflo-widget-communication-icon"}
      style="--accent-color: {accentColor};"
    >
      <SmsIcon />
      {#if $selected_communication === "sms"}
        <hr
          class="verbaflo-widget-communication-horizontal-line"
          style="--accent-color: {accentColor};"
        />
      {/if}
    </button>
  {/if}
  {#if fb_messenger_modality_enabled}
    <button
      type="button"
      on:click={() => handleCommunicationToggle("fb_messenger")} 
      class={$selected_communication === "fb_messenger"
        ? "verbaflo-widget-communication-icon-selected"
        : "verbaflo-widget-communication-icon"}
      style="--accent-color: {accentColor};"
    >
      <FbIcon size="20px" />
      {#if $selected_communication === "fb_messenger"} 
        <hr
          class="verbaflo-widget-communication-horizontal-line"
          style="--accent-color: {accentColor};"
        />
      {/if}
    </button>
  {/if}
  {#if instagram_modality_enabled}
    <button
      type="button"
      on:click={() => handleCommunicationToggle("instagram")}
      class={$selected_communication === "instagram"
        ? "verbaflo-widget-communication-icon-selected"
        : "verbaflo-widget-communication-icon"}
      style="--accent-color: {accentColor};"
    >
      <InstagramSolidIcon  />
      {#if $selected_communication === "instagram"}
        <hr
          class="verbaflo-widget-communication-horizontal-line"
          style="--accent-color: {accentColor};"
        />
      {/if}
    </button>
  {/if}
  {#if wechat_modality_enabled}
    <button
      type="button"
      on:click={() => handleCommunicationToggle("wechat")}
      class={$selected_communication === "wechat"
        ? "verbaflo-widget-communication-icon-selected"
        : "verbaflo-widget-communication-icon"}
      style="--accent-color: {accentColor};"
    >
      <WechatIcon />
      {#if $selected_communication === "wechat"}
        <hr
          class="verbaflo-widget-communication-horizontal-line"
          style="--accent-color: {accentColor};"
        />
      {/if}
    </button>
  {/if}
</div>

<style>
  :global(#vfwidget .verbaflo-widget-communications-container) {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    column-gap: 28px !important;
    padding: 10px 0px !important;
  }

  :global(#vfwidget .verbaflo-widget-communication-icon) {
    color: var(--accent-color) !important;
    background-color: transparent !important;
    border: none !important;
    cursor: pointer !important;
    padding: 0 !important;
    margin: 0 !important;
    transition: color 0.3s ease !important;
  }

  :global(#vfwidget .verbaflo-widget-communication-icon:hover),
  :global(#vfwidget .verbaflo-widget-communication-icon:active) {
    opacity: 1 !important;
    text-decoration: none !important;
  }

  :global(#vfwidget .verbaflo-widget-communication-icon-selected) {
    color: var(--accent-color) !important;
    background-color: transparent !important;
    border: none !important;
    cursor: pointer !important;
    display: flex !important;
    flex-direction: column !important;
    row-gap: 3px !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  :global(#vfwidget .verbaflo-widget-communication-icon-selected:hover),
  :global(#vfwidget .verbaflo-widget-communication-icon-selected:active) {
    opacity: 1 !important;
    text-decoration: none !important;
  }

  :global(#vfwidget .verbaflo-widget-communication-horizontal-line) {
    background-color: var(--accent-color) !important;
    width: 100% !important;
    height: 2px !important;
    border: transparent !important;
    border-radius: 50px !important;
    margin: 0 !important;
  }
</style>
